import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, renderSlot as _renderSlot, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = ["onClick"]
const _hoisted_2 = { class: "w-4 h-4 border border-white rounded-full p-[3px]" }
const _hoisted_3 = {
  key: 0,
  class: "w-full h-full bg-white rounded-full"
}
const _hoisted_4 = { class: "flex flex-col gap-2 justify-center items-start" }


export default /*#__PURE__*/_defineComponent({
  __name: 'Button',
  props: {
  active: Boolean
},
  emits: ["click"],
  setup(__props, { emit }: { emit: ({
  (e: 'click'): void
}), expose: any, slots: any, attrs: any }) {





function handleClick() {
  emit('click')
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("button", {
    class: "flex justify-start gap-2",
    onClick: _withModifiers(handleClick, ["stop"])
  }, [
    _createElementVNode("div", _hoisted_2, [
      (__props.active)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_4, [
      _renderSlot(_ctx.$slots, "label"),
      _renderSlot(_ctx.$slots, "addon")
    ])
  ], 8, _hoisted_1))
}
}

})